export default {
  AD: 'Andorra',
  AF: 'Afghanistan',
  EG: 'Egitto',
  EH: 'Sahara occidentale',
  FO: 'Isole Faroe',
  GA: 'Gabon',
  GD: 'Granada',
  GI: 'Gibilterra',
  GM: 'Gambia',
  AG: 'Antigua e Barbuda',
  AI: 'Anguilla',
  AL: 'Albania',
  AN: 'Antille Olandesi',
  AO: 'Angola',
  AQ: 'Antartide',
  AR: 'Argentina',
  AU: 'Australia',
  AW: 'Aruba',
  AZ: 'Azerbaigian',
  BA: 'Bosnia Erzegovina',
  BB: 'Barbado',
  BF: 'Burkina Faso',
  BG: 'Bulgaria',
  BH: 'Bahrein',
  BI: 'Burundi',
  BJ: 'Benin',
  BM: 'Bermuda',
  BS: 'Bahamas',
  BV: 'Isola Bouvet',
  BW: 'Botswana',
  BZ: 'Belize',
  CA: 'Canada',
  CF: 'Africa centrale',
  CG: 'Congo',
  CI: 'Costa d\'Avorio',
  CK: 'Isole Cook',
  CN: 'Cina',
  CU: 'Cuba',
  CV: 'Capo Verde',
  DE: 'Germania',
  EC: 'Ecuador',
  GR: 'Grecia',
  IR: 'Iran',
  IT: 'Italia',
  JM: 'Giamaica',
  JO: 'Giordania',
  JP: 'Giappone',
  KE: 'Kenia',
  KM: 'Comore',
  KP: 'Corea del nord',
  KR: 'Corea del Sud',
  LB: 'Libano',
  LS: 'Lesotho',
  LU: 'Lussemburgo',
  LV: 'Lettonia',
  MD: 'Moldavia',
  GU: 'Guam',
  HK: 'Hong Kong',
  HM: 'Isole Heard e Isole Mc Donald',
  HT: 'Haiti',
  MK: 'Macedonia',
  ML: 'Mali',
  MN: 'Mongolia',
  HU: 'Ungheria',
  ID: 'Indonesia',
  IE: 'Irlanda',
  IL: 'Israele',
  IN: 'India',
  IQ: 'Iraq',
  MT: 'Malta',
  MV: 'Maldive',
  MX: 'Messico',
  NC: 'Nuova Caledonia',
  NI: 'Nicaragua',
  NZ: 'Nuova Zelanda',
  PE: 'Perù',
  PL: 'Polonia',
  PT: 'Portogallo',
  PW: 'Palù',
  CR: 'Costa Rica',
  CZ: 'Repubblica Ceca',
  DZ: 'Algeria',
  ET: 'Etiopia',
  FR: 'Francia',
  RO: 'Romania',
  RU: 'Russia',
  SA: 'Arabia Saudita',
  SB: 'Isole Salomone',
  SC: 'Seychelles',
  SD: 'Sudan',
  SE: 'Svezia',
  SG: 'Singapore',
  SI: 'Slovenia',
  SJ: 'Isole Svalbard e Jan Mayen',
  SK: 'Slovacchia',
  SL: 'Sierra Leone',
  SN: 'Senegal',
  SO: 'Somalia',
  SR: 'Suriname',
  ST: 'Sao Tomè e Principe',
  SV: 'El Salvador',
  SZ: 'Swaziland',
  TC: 'Isole Turks e Caicos',
  TD: 'Chad',
  TF: 'Territori della Francia del sud',
  TG: 'Andare',
  TH: 'Tailandia',
  TK: 'Tokelau',
  TM: 'Turkmenistan',
  TN: 'Tunisia',
  TP: 'Timor Est',
  TT: 'Trinidad e Tobago',
  UA: 'Ucraina',
  US: 'Stati Uniti',
  UZ: 'Uzbekistan',
  VA: 'Vaticano',
  VE: 'Venezuela',
  VG: 'Isole Vergini Britanniche',
  VU: 'Vanuatu',
  YE: 'Yemen',
  YT: 'Maionese',
  YU: 'Jugoslavia',
  ZA: 'Sud Africa',
  ZW: 'Zimbabwe',
  GB: 'Regno Unito',
  BO: 'Bolivia',
  BT: 'Bhutan',
  BY: 'Bielorussia',
  CC: 'Isole Cocos (Keeling)',
  CL: 'Chile',
  CO: 'Colombia',
  TW: 'Taiwan, Cina',
  CY: 'Cipro',
  DK: 'Danimarca',
  DO: 'Repubblica Dominicana',
  ES: 'Spagna',
  FI: 'Finlandia',
  FK: 'Isole Malvinas (Isole Falkland)',
  GE: 'Georgia',
  GL: 'Groenlandia',
  GN: 'Guinea',
  GS: 'South Georgia and South Sandwich Islands',
  KW: 'Kuwait',
  KZ: 'Kazakhstan',
  LT: 'Lithuania',
  LY: 'Libya',
  MH: 'Marshall Islands',
  MO: 'Macau',
  MU: 'Mauritius',
  MY: 'Malaysia',
  NA: 'Namibia',
  NU: 'Niue',
  OM: 'Oman',
  PK: 'Pakistan',
  PR: 'Puerto Rico',
  AT: 'Austria',
  BD: 'Bangladesh',
  CH: 'Switzerland',
  CS: 'Christmas Island',
  FM: 'Micronesia',
  IO: 'British indian Ocean Ter-ritory',
  KI: 'Kiribati',
  LC: 'Saint lucia',
  MA: 'Morocco',
  MM: 'Myanmar',
  MS: 'Montserrat',
  NG: 'Nigeria',
  PH: 'Philippines',
  RE: 'Reunion',
  WS: 'Western Samoa',
  AE: 'United Arab Emirates',
  AS: 'American Samoa',
  BE: 'Belgium',
  BN: 'Brunei Darussalam',
  CM: 'Cameroon',
  DJ: 'Djibouti',
  ER: 'Eritrea',
  GF: 'French Guiana',
  GW: 'Guine-bissau',
  HR: 'Croatia',
  IS: 'Iceland',
  KH: 'Cambodia',
  KY: 'Cayman Islands',
  LR: 'Liberia',
  MQ: 'Martinique',
  MZ: 'Mozambique',
  PA: 'Panama',
  PN: 'Pitcairn Islands Group',
  RW: 'Rwanda',
  SH: 'Saint helena',
  SM: 'San Marion',
  SY: 'Syria',
  TJ: 'Tajikistan',
  TZ: 'Tanzania',
  EE: 'Estonia',
  LI: 'Liechtenstein',
  NF: 'Norfolk Island',
  PY: 'Paraguay',
  GP: 'Guadeloupe',
  UM: 'United States miscella-neous Pac',
  NP: 'Nepal',
  PM: 'Saint Pierre and Miquelon',
  GQ: 'Equatorial Guinea',
  GY: 'Guyana',
  KG: 'Kyrgyzstan',
  KN: 'Saint Kitts and nevis',
  LA: 'Lao',
  LK: 'Sri Lanka',
  MC: 'Monaco',
  MG: 'Madagascar',
  MR: 'Mauritania',
  MW: 'Malawi',
  NE: 'Niger',
  NO: 'Norway',
  NR: 'Nauru',
  PG: 'Papua New Guinea',
  PS: 'Palestine',
  QA: 'Qatar',
  RS: 'Serbia',
  MP: 'Northern Marianas',
  NL: 'Netherlands',
  PF: 'French Polynesia',
  AM: 'Armenia',
  BR: 'Brazil',
  DM: 'Dominica',
  HN: 'Honduras',
  TO: 'Tonga',
  TR: 'Turkey',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UY: 'Uruguay',
  VC: 'Saint Vincent and the Grenadines',
  VI: 'United States Virgin Is-lands',
  WF: 'Wallis and Futuna Is-lands',
  ZM: 'Zambia',
  FJ: 'Fiji',
  GH: 'Ghana',
  GT: 'Guatemala',
  VN: 'Viet Nam',
  ZR: 'Zaire',
};
